//TODO: use proper css class names instead of #IDs


function initRedemption(memberNo, offerID) {
    $.ajax({
        url: "/api/redemption/" + offerID + "/add"
    }).done(function (res) {
        if (res.Status === 200) {            
            addRedemptionIntoLocalStorage(memberNo, offerID, function (success) {
                if (success) {
                    window.location = "/offer/redemption/" + offerID;
                } else {
                    $(".redeem").hide();
                }
            });
        }
    }).fail(function (jqXHR) {
        if (jqXHR.status === 401) {
            var loginPath = $("body").data("login-path");
            window.location = loginPath + '?returnUrl=' + encodeURIComponent(window.location.pathname);
        }
    });
}

function getCurrentLocalStorage(memberNo) {
    var st = localStorage["fvredeem" + memberNo];

    var storage = st != null ? JSON.parse(st) : [];
    if (storage == null) {
        storage = [];
    }
    return storage;
}

function addRedemptionIntoLocalStorage(memberNo, offerID, onAfterAdded) {
    var storage = getCurrentLocalStorage(memberNo);

    var today = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    var exists = false;
    for (var i in storage) {
        if (storage[i].ID === offerID.toString()) {
            var now = new Date();
            var storedDate = new Date(storage[i].ValidTo);
            if (storedDate > now) {
                if (storage[i].Redeemed) {
                    alert("Offer was already redeemed");
                    onAfterAdded(false);
                } else {
                    onAfterAdded(true);
                }
                return false;
            } else {
                storage[i].ValidTo = tomorrow;
                storage[i].Redeemed = false;
            }
            exists = true;
        }
    }
    if (!exists) {
        var item = {};
        item.ValidTo = tomorrow;
        item.ID = offerID;
        item.Redeemed = false;
        storage.push(item);
    }
    var stobj = JSON.stringify(storage);
    localStorage["fvredeem" + memberNo] = stobj;
    onAfterAdded(true);
}

function confirmRedemption(memberNo, offerID, tomorrow) {
    confirmRedemptionLocaly(memberNo, offerID, true, tomorrow);
    confirmRedemptionRemotelly(memberNo, offerID);
    disableRedemption();
}

function confirmRedemptionRemotelly(memberNo, offerID) {
    $.get('/api/redemption/' + offerID + '/redeem',
        function(data) {
            $("#uiBtnBackPnl").show();            
            if (data.Status === 200) {
                var newArray = [];
                var getstorage = JSON.parse(localStorage["fvredeem" + memberNo]);
                for (var y in getstorage) {
                    if (getstorage[y].ID !== offerID.toString()) {
                        newArray.push(getstorage[y]);
                    }
                }
                var getStNew = JSON.stringify(newArray);
                localStorage["fvredeem" + memberNo] = getStNew;
            }
        });
}

function confirmRedemptionLocaly(memberNo, offerID, redeem, tomorrow) {
    var storage = getCurrentLocalStorage(memberNo);

    var found = false;
    for (var i in storage) {
        if (storage[i].ID === offerID.toString()) {
            found = true;
            if (redeem) {
                storage[i].Redeemed = true;
            } else {
                var now = new Date();
                var storedDate = new Date(storage[i].ValidTo);
                if (storedDate > now && storage[i].Redeemed) {
                    disableRedemption();
                    alert("Offer was already redeemed");
                } else {
                    startCountDown(storage[i].ValidTo);
                }
            }
        }
    }
    if (!found && !redeem) {                                                   
        startCountDown(tomorrow);
    }
    if (found && redeem) {
        var stobj = JSON.stringify(storage);
        localStorage["fvredeem" + memberNo] = stobj;
    }
}

function startCountDown(untilDate) {
    tomorrowCount = new Date(untilDate);
    timedCount();
}

var tomorrowCount = new Date();
var timer;
function timedCount() {
    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var todayCount = new Date();
    var distance = tomorrowCount.getTime() - todayCount.getTime();
    if (distance < 0) {
        clearInterval(timer);
        $(".RedeemBtn").remove();

        disableRedemption();
        alert("Time to redeem this offer expired.");
        return;
    }
    var hours = Math.floor((distance % day) / hour);
    var minutes = Math.floor((distance % hour) / minute);
    var seconds = Math.floor((distance % minute) / second);

    var res = " " + hours + "h " + minutes + "m and " + seconds + "s";
    $("#uiValidUntil").text(res);
    timer = setTimeout("timedCount()", 1000);
}

function disableRedemption() {
    $("#uiVoucherText").hide();
    $("#uiThanksInfo").show();
    $("#uiLblSerialNumber").show();
    $("#uiBtnRedeem").hide();
    $("#uiBtnCancel").hide();
    $("#uiBtnDisclaimer").hide();
    $("#uiValidInfo").hide();
}

function cancelRedeem(memberNo, offerID) {
    clearInterval(timer);
    localStorage.removeItem("fvredeem" + memberNo);
    $.get('/api/redemption/' + offerID + '/cancel',
        function (data) {
            $("#uiBtnBackPnl").show();            
            if (data.Status === 200) {
                //we don't need to do anything with the result
            }

            var searchUrl = localStorage.fvsearchurl;
            if (searchUrl == null) {
                searchUrl = "/search";
            } else {
                searchUrl = unescape(searchUrl);
            }
            window.location = searchUrl;
        }, function () {
            var searchUrl = localStorage.fvsearchurl;
            if (searchUrl == null) {
                searchUrl = "/search";
            } else {
                searchUrl = unescape(searchUrl);
            }
            window.location = searchUrl;
        });
}

function goBack() {
    var searchUrl = localStorage.fvsearchurl;
    if (searchUrl == null) {
        searchUrl = "/search";
    } else {
        searchUrl = unescape(searchUrl);
    }
    window.location = searchUrl;
    return false;
}